import React, { FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IBaseComponent } from '../../sharedInterfaces/IBaseComponent';
import { getDefaultLabelName } from '../../services/DefaultLabelNameService';
import { setInput } from '~/actions/formActions';
import { TERMS_AGREEMENT } from '~/actions/actionTypes';
import { IState } from '~/sharedInterfaces/IState';
import { IBaseInput, ITermsText } from '~/sharedInterfaces/SharedInterfaces';
import { getInputClassNames } from '~/utils';

export interface ITermsAgreement extends IBaseInput {}

interface ITermsAgreementProps extends ITermsAgreement, IBaseComponent {}

const TermsAgreement: FC<ITermsAgreementProps> = (props) => {
  const dispatch = useDispatch();
  const { locale } = useSelector((state: IState) => state.widgetContext);

  useEffect(() => {
    dispatch(setInput(TERMS_AGREEMENT, true));
  }, []);

  const termsText = getDefaultLabelName(locale, TERMS_AGREEMENT) as ITermsText;

  return (
    <div
      className={getInputClassNames({
        componentName: props.componentName,
        tooltip: false,
        additionalClassName: 'qred-row',
      })}
    >
      <p className="qred-first">
        <span className="qred-first">
          {termsText.start}
          <a href={termsText.url} target="_blank" rel="noreferrer">
            {termsText.urlText}
          </a>
          {termsText.end}
        </span>
      </p>
    </div>
  );
};

export default TermsAgreement;
